import { Deployment } from '../../../types';

interface StatusPillProps {
    isPublished: boolean | undefined;
    deployment?: Deployment | null;
}

export default function StatusPill({ isPublished, deployment }: StatusPillProps) {
    // If isPublished is undefined, treat it as false (draft)
    const isPublishedStatus = isPublished ?? false;

    if (!isPublishedStatus) {
        return (
            <span className="px-1.5 py-0.5 bg-gray-100 text-gray-600 text-xs font-medium rounded-md inline-flex items-center gap-1">
                <span className="h-1.5 w-1.5 rounded-full bg-gray-500"></span>
                Draft
            </span>
        );
    }

    if (deployment) {
        const statusColors = {
            completed: "bg-green-100 text-green-600",
            failed: "bg-red-100 text-red-600",
            in_progress: "bg-yellow-100 text-yellow-600",
            default: "bg-gray-100 text-gray-600"
        };

        const dotColors = {
            completed: "bg-green-500",
            failed: "bg-red-500",
            in_progress: "bg-yellow-500",
            default: "bg-gray-500"
        };

        const statusColor = statusColors[deployment.status.toLowerCase() as keyof typeof statusColors] || statusColors.default;
        const dotColor = dotColors[deployment.status.toLowerCase() as keyof typeof dotColors] || dotColors.default;

        return (
            <span className={`px-1.5 py-0.5 ${statusColor} text-xs font-medium rounded-md inline-flex items-center gap-1 capitalize`}>
                <span className={`h-1.5 w-1.5 rounded-full ${dotColor}`}></span>
                {deployment.status}
            </span>
        );
    }

    return null;
} 